import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig, SupplyWalkParams } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { useCustomer } from "../../contexts/app/provider";
import { getSupplyWalkTableData } from "../../utils/mui_flat_table_data";

export const SupplyWalkNoPerspectiveContainer = () => {
  const { selectedCustomerId } = useCustomer();

  // Customer-specific date hierarchy configurations
  let dateHierarchyColumnFilter: Record<string, string>;

  if (selectedCustomerId === "glowco") {
    dateHierarchyColumnFilter = {
      week: "week",
      month: "month",
      day: "day",
    };
  } else {
    dateHierarchyColumnFilter = {
      week: "week",
      month: "month",
      day: "day",
    };
  }

  return (
    <TransformedCustomViewContainer<SupplyWalkParams>
      viewControllerConfig={{
        datasetName: "supply_walk_test",
        transformId: "supply_walk_parallelized",
        folder: "outputs",
        title: "Supply Walk",
        dateHierarchyColumnFilter,
        excludedSegmentationsFilter: [],
        measureColumnFilter: {},
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.PostFilterByHardcodedColumns,
          PivotControl.Download,
        ],
        hardcodedColumns: [
          // {
          //   name: "include_atomic_purchase_plan",
          //   caption: "Include Atomic Purchase Plan",
          //   unique_values: ["true", "false"],
          // },
          {
            name: "has_near_term_purchase",
            caption: "Has Near Term Purchase",
            unique_values: ["true", "false"],
          },
          {
            name: "has_near_term_arrivals",
            caption: "Has Near Term Arrivals",
            unique_values: ["true", "false"],
          },
          {
            name: "has_near_term_stock_risk",
            caption: "Has Near Term Stock Risk",
            unique_values: ["true", "false"],
          },
        ],
        paramsToTransformArgs,
        getMatrix: getSupplyWalkTableData,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
